import {DatePickerPresetKeys, getPresetDateRangeIso} from "../DatePicker/DatePicker"

// Unscoped (homepage) list: shortest to longest range, "All time" last.
const UNSCOPED_DATE_PRESETS = [
	DatePickerPresetKeys.yesterday,
	DatePickerPresetKeys.last7Days,
	DatePickerPresetKeys.last30Days,
	DatePickerPresetKeys.lastMonth,
	DatePickerPresetKeys.last3Months,
	DatePickerPresetKeys.last6Months,
	DatePickerPresetKeys.custom,
	DatePickerPresetKeys.allTime,
]

// Scoped lists (customer/account/card pages) keep their original order.
const SCOPED_DATE_PRESETS = [
	DatePickerPresetKeys.allTime,
	DatePickerPresetKeys.yesterday,
	DatePickerPresetKeys.lastMonth,
	DatePickerPresetKeys.last3Months,
	DatePickerPresetKeys.last6Months,
	DatePickerPresetKeys.last30Days,
	DatePickerPresetKeys.last7Days,
	DatePickerPresetKeys.custom,
]

export function getDatePresets(isScopedView: boolean) {
	return isScopedView ? SCOPED_DATE_PRESETS : UNSCOPED_DATE_PRESETS
}

// Unscoped lists default to a bounded range to keep full-text search fast.
// Scoped lists are index-friendly and keep "All time".
export function getDefaultDatePreset(isScopedView: boolean, isOrgUser: boolean) {
	if (isScopedView) return DatePickerPresetKeys.allTime
	return isOrgUser ? DatePickerPresetKeys.last30Days : DatePickerPresetKeys.last7Days
}

// The picker keeps its selection in local state and re-applies its initial preset on mount,
// overwriting the URL. For unscoped lists, derive the initial preset from the URL's `since` so a
// reload keeps the user's choice (e.g. "All time"). Falls back to the default for ranges that
// match no preset. Scoped lists always start from their default.
export function getInitialDatePreset(since: string, isScopedView: boolean, fallback: DatePickerPresetKeys) {
	if (isScopedView) return fallback
	if (since === "") return DatePickerPresetKeys.allTime
	return (
		UNSCOPED_DATE_PRESETS.find(
			(preset) => preset !== DatePickerPresetKeys.custom && getPresetDateRangeIso(preset).since === since
		) ?? fallback
	)
}
